import "acf-maps.js"
import "flickity/flickity-min.js"

( function( $ ) {
   
  ///// MOBILE NAV /////
  $(document).on('click', '.js-navModal-toggle', function() {	  
    $(this).toggleClass('-open');
    $('body, .js-header').toggleClass('-navModal-open');
    $('.js-navModal').toggleClass('-collapsed');
  });
  
  
  ///// HEADER SCROLL /////
  var header = $(".js-header");
  var scrollTop = 0;
  
  $(window).on('scroll load', function() {	  
	  scrollTop = $(this).scrollTop();	  
	  if (scrollTop > 100) {
		  header.addClass('-scrolled');
	  } else {
		  header.removeClass('-scrolled');
	  }	  
  });
	
	
	///// FLICKITY /////
	$('.js-carousel').flickity({
		cellAlign: 'left',
	 	cellSelector: '.js-carousel-item',
	  watchCSS: true,
	  pageDots: false,
	  prevNextButtons: false,
	  contain:false,
	});
  
  //---------------------------//
	// OPEN EXTERNAL LINKS IN NEW TAB
	//---------------------------//
		
    $.expr[':'].external = function(obj) {
        return (!obj.href.match(/^mailto\:/) && (obj.hostname !== location.hostname) && !obj.href.match(/^javascript\:/) && !obj.href.match(/^$/));
    };
			
    $("a[href$='pdf']").attr('target', '_blank');
    $("a[href$='doc']").attr('target', '_blank');
    $("a[href$='docx']").attr('target', '_blank');
    $('a:external').attr('target', '_blank');


  
} )( jQuery );